import { QldContractStage, NswContractStage } from '@urbanx/agx-ui-components';
import { Tabs } from 'types/Tabs';
import ResumeContractSubmission from './ResumeContractSubmission';
import ContractSubmitPanel from './ContractSubmitPanel';
import { getEnumValue } from 'helpers/enumHelper';
import { CampaignDetailModelState, ContractDetailModel } from '@urbanx/agx.campaigns.client';
import { useNewSelectedCampaign } from 'hooks/useNewSelectedCampaign';

interface ContractSubmissionInfoPanelProps {
  state: CampaignDetailModelState;
  contract: ContractDetailModel;
  currentTab: Tabs;
  mobile?: boolean;
}

const ContractSubmissionInfoPanel = ({
  state,
  contract,
  currentTab,
  mobile = false,
}: ContractSubmissionInfoPanelProps) => {
  const { selectedCampaign } = useNewSelectedCampaign();
  const { contractStage: stage } = contract;

  const resumeStages = [
    QldContractStage.ContractDraft,
    QldContractStage.BuyerSigning,
    QldContractStage.SignedByBuyer,
    QldContractStage.SignedByAllParties,
    QldContractStage.SubmissionIncomplete,
    NswContractStage.ContractDraft,
    NswContractStage.SalesAdviceDraft,
    NswContractStage.PendingAgentExchange,
    NswContractStage.SubmissionIncomplete,
  ];

  const submitStages = [
    QldContractStage.Accepted,
    QldContractStage.Unconditional,
    QldContractStage.Terminated,
    QldContractStage.Settled,
    QldContractStage.BackUp,
    QldContractStage.PendingCompliance,
    NswContractStage.Accepted,
    NswContractStage.Unconditional,
    NswContractStage.Terminated,
    NswContractStage.Settled,
    NswContractStage.ContractRequested,
    NswContractStage.PendingCompliance,
    NswContractStage.PendingSolicitorExchange,
  ];

  if (!stage) throw new Error('Contract stage is undefined');

  const enumType = state === CampaignDetailModelState.QLD ? QldContractStage : NswContractStage;

  const contractStage = getEnumValue(enumType, stage) ?? stage;
  const nswContractStage = getEnumValue(NswContractStage, stage) ?? (stage as NswContractStage);

  const nswContractRequested =
    state === CampaignDetailModelState.NSW &&
    nswContractStage === NswContractStage.ContractRequested;

  if (selectedCampaign && contractStage && resumeStages.includes(contractStage))
    return (
      <ResumeContractSubmission
        currentTab={currentTab}
        campaign={selectedCampaign}
        contract={contract}
        mobile={mobile}
      />
    );
  if (selectedCampaign && contractStage && submitStages.includes(contractStage))
    return (
      <ContractSubmitPanel
        campaign={selectedCampaign}
        currentTab={currentTab}
        showDownload={!nswContractRequested}
        showSubmit={false}
      />
    );

  return null;
};

export default ContractSubmissionInfoPanel;
